import { iconContent, mediaMax, theme } from "@customer-tools-web/component-ui";
import { createGlobalStyle } from "styled-components";
import styledNormalize from "styled-normalize";
export const GlobalStyles = createGlobalStyle`
  ${styledNormalize}
  html {
    font-size: 62.5%;
    font-family: Mulish, Inter, sans-serif;
    input {
      &::-webkit-input-placeholder {
        font-size: ${(props) => props?.theme?.fontSize?.body} !important;
      }
    }
  }
  ul {
    padding: 0;
    margin: 0;
  }
  li {
    list-style: none;
  }
  #root {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    min-width: 320px;
  }

  body {
    font-size: 1.4rem !important; // override to default font-size, avoid being affected by verified agent banner styles

    // override agentnet-widgets global style leak that adds text-decoration: underline to all links
    a {
      text-decoration: none;
    }

    &.forbidden-scroll #root{
      overflow: hidden;
      height: ${(props) =>
        props?.theme?.isMobile === "true"
          ? "calc(var(--vh, 1vh) * 100)"
          : "100vh"};
    }

    strong {
      font-weight: 700;
    }

    .ant-input, .ant-input-number-input {
      &::placeholder {
        color: ${({ theme }) => theme?.inputPlaceholderColor};
        font-weight: 400;
      }
    }

    .ant-select-selection__placeholder, .ant-select-search__field__placeholder {
      color: ${({ theme }) => theme?.inputPlaceholderColor};
      font-weight: 400;
      font-size: ${(props) => props?.theme?.fontSize?.body};
    }

    .ant-select-selection__choice__content {
      font-size: ${(props) => props?.theme?.fontSize?.body};
    }

    .ant-input, .ant-input-number, .ant-select {
      color: ${({ theme }) => theme?.textColor};
    }

    .ant-input-disabled, .ant-input-number-disabled, .ant-select-disabled {
      color: ${({ theme }) => theme?.inputDisabledColor};
      &::placeholder, .ant-select-selection__placeholder, .ant-select-search__field__placeholder{
        color: ${({ theme }) => theme?.inputDisabledColor};
      }
    }

    .ant-select-auto-complete {
      &.ant-select {
        .ant-input[disabled] {
          color: ${({ theme }) => theme?.inputDisabledColor};
          &::placeholder{
            color: ${({ theme }) => theme?.inputDisabledColor};
          }
        }
      }
    }

    .ant-select-arrow {
      margin-top: -8px;
    }
    .anticon.ant-select-arrow-icon {
      font-family: "rui-icon", sans-serif;
      font-style: normal;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      font-size: ${(props) => props?.theme?.fontSize?.body};
      color: ${({ theme }: any) => theme?.textDeepGray};
      transition: transform ease-in-out .3s;
      svg {
        display: none;
      }
      &:after {
        content: "${iconContent["arrow-down"]}";
      }
    }
    .ant-select-open .anticon.ant-select-arrow-icon {
      transform: rotate(180deg);
    }
    .ant-checkbox-wrapper {
      color: ${(props) => props?.theme?.textDeepGray};
      display: flex;
      align-items: center;
      .ant-checkbox {
        margin-top: 3px;
        height: 16px;
      }
    }
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${(props) => props?.theme?.checkboxCheckBg};
      border-color: ${(props) => props?.theme?.checkboxCheckBorder};
    }

    .ant-checkbox-inner {
      width: 16px;
      height: 16px;
      border: 2px solid ${(props) => props?.theme?.textDeepGray};
      &::after {
        width: 6px;
        height: 10px;
        top: 5px;
        left: 2px;
      }
    }

    .ant-tabs-bar {
      border-bottom-color: ${(props) => props?.theme?.tabsBarBorder};
    }

    .ant-tabs-nav-container {
      color: ${(props) => props?.theme?.tabsNavColor};
      font-size: ${(props) => props?.theme?.fontSize?.body};
      font-weight: ${(props) => props?.theme?.tabsNavFontWeight};
    }
    .ant-tabs-nav .ant-tabs-tab:active,
    .ant-tabs-nav .ant-tabs-tab-active {
      color: ${(props) => props?.theme?.tabsNavActiveColor};
      font-weight: ${(props) => props?.theme?.tabsNavActiveFontWeight};
    }
    .ant-tabs-nav .ant-tabs-tab:hover {
      color: ${(props) => props?.theme?.tabsNavActiveColor};
    }

    .ant-tabs-ink-bar {
      background-color: ${(props) => props?.theme?.tabsInkBarColor};
    }

    .ant-modal-close-x .ant-modal-close-icon {
      font-family: "rui-icon", sans-serif;
      font-style: normal;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      font-size: ${(props) => props?.theme?.fontSize?.title2};
      font-weight: 700;
      color: ${({ theme }: any) => theme?.textColor};
      transition: transform ease-in-out .3s;
      svg {
        display: none;
      }
      &::after {
        content: "${iconContent?.cross}";
      }
    }

    .ant-tooltip {
      max-width: 450px;
      ${mediaMax.md`
        max-width: 350px;
      `};
      ${mediaMax.sm`
        max-width: 250px;
      `};
      .ant-tooltip-inner {
        background-color: ${theme?.textColor};
      }
    }
  }

  .ct-loading-mask {
    position: fixed;
    z-index: 2000;
    background-color: transparent;
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: opacity 0.3s;
  }
`;
